import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';

import { DomService } from 'ish-core/utils/dom/dom.service';

import { dotCMSNavigationLink, isIndexPagePresent } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-header-folder-index-page-check',
  templateUrl: './dot-cms-header-folder-index-page-check.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsHeaderFolderIndexPageCheckComponent {
  readonly navLink = input<DotCMSNavigationItem>(undefined);
  readonly depth = input<number>(undefined);
  readonly dropDownLayer = input<number>(undefined);
  readonly deviceType = input<string>(undefined);

  isHavingIndexPage = isIndexPagePresent;
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;

  constructor(private domService: DomService) {}

  hideFlyout(id: number) {
    this.domService.getElementById(`dot-cms-header-flyout${id}`).classList.add('d-none');
  }
}
